import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { IFormaPagamentoSefaz } from '../models/forma-pagamento-sefaz.model';

@Injectable()
export class FormaPagamentoSefazService extends EntityService<
  IFormaPagamentoSefaz
> {
  constructor(protected configService: ConfigService) {
    super(
      {
        baseEntityEndPoint: 'formas_pagamento_sefaz',
        pluralBaseEntityEndPoint: 'formas_pagamento_sefaz',
        urlBackend: configService.backendURL
      }
    );
  }
}
